import { render, staticRenderFns } from "./DonutChart51.vue?vue&type=template&id=22822146&scoped=true"
import script from "./DonutChart51.vue?vue&type=script&lang=js"
export * from "./DonutChart51.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22822146",
  null
  
)

export default component.exports